import { render, staticRenderFns } from "./dataConfig.vue?vue&type=template&id=fb420d8e&"
import script from "./dataConfig.vue?vue&type=script&lang=js&"
export * from "./dataConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports